import React, { useMemo } from 'react'
import { SwapCalls, Toll } from '@material-ui/icons'
import { Icon } from '../Icon'
import { ReactComponent as Agriculture } from 'Assets/Icons/Agriculture.svg'

import './Button.scss'

const MuiIcons = {
  Toll,
  SwapCalls,
  Agriculture
}

const Button: React.FC<{
  onClick?: () => void
  disabled?: boolean
  white?: boolean
  blue?: boolean
  green?: boolean
  icon?: string
}> = (props) => {
  const classes = useMemo(() => {
    const clss: string[] = []
    props.white && clss.push('white')
    props.blue && clss.push('blue')
    props.green && clss.push('green')
    return clss.join(' ')
  }, [props])

  const IconComponent = useMemo(() => {
    if (props.icon) {
      if (Object.keys(MuiIcons).includes(props.icon)) {
        const iconName = props.icon as keyof typeof MuiIcons
        return MuiIcons[iconName]
      }

      return () => <Icon icon={props.icon!} />
    }

    return null
  }, [props.icon])

  return (
    <button
      className={`Button ${classes}`}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      {IconComponent && (
        <span className="Button__icon">
          <IconComponent />
        </span>
      )}
      <span>{props.children}</span>
    </button>
  )
}

export default Button
